import React from "react";

import CatalogCrudPage from "./CatalogCrudPage";
import { formatsService } from "../../services";

export default function FormatsPage() {
  return (
    <CatalogCrudPage
      title="Formatos"
      subtitle="Administracion de formatos de producto"
      addTabPath="/settings/formats"
      addTabLabel="Formatos"
      service={formatsService}
      hasDescription={false}
      viewPerms={["view_formats"]}
      managePerms={["manage_formats"]}
    />
  );
}
